import { gql } from '@apollo/client'

export const MY_USER_DEFINED_PROMPTS = gql`
  query myUserDefinedPrompts($purpose: String!) {
    myUserDefinedPrompts(purpose: $purpose) {
      id
      name
      content
      purpose
      createdAt
      updatedAt
    }
  }
`

export const CREATE_USER_DEFINED_PROMPT = gql`
  mutation createUserDefinedPrompt($data: UserDefinedPromptInput!) {
    createUserDefinedPrompt(data: $data) {
      id
      name
      content
      purpose
      createdAt
      updatedAt
    }
  }
`

export const UPDATE_USER_DEFINED_PROMPT = gql`
  mutation updateUserDefinedPrompt($data: UserDefinedPromptUpdateInput!) {
    updateUserDefinedPrompt(data: $data) {
      id
      name
      content
      purpose
      createdAt
      updatedAt
    }
  }
`

export const DELETE_USER_DEFINED_PROMPT = gql`
  mutation deleteUserDefinedPrompt($id: ID!) {
    deleteUserDefinedPrompt(id: $id)
  }
`

export const DEFAULT_WIP_CLIENT_SUMMARY_SYSTEM_PROMPT = gql`
  query defaultWipClientSummarySystemPrompt {
    defaultWipClientSummarySystemPrompt
  }
`
